import React from 'react';
import Button from './Button';

const STATEMENT_PDF = '/documents/IFYS_Statement_of_Commitment_2026.pdf';

const WhoWeAre = () => {
  return (
    <section id="content-start" className="relative bg-white py-16 md:py-24 overflow-hidden">
      {/* Aboriginal artwork - top left */}
      <img
        src="/images/image.png"
        alt=""
        aria-hidden
        loading="lazy"
        className="hidden md:block absolute -top-44 -left-44 w-96 h-96 object-cover rounded-full pointer-events-none z-0"
      />
      {/* Aboriginal artwork - bottom right */}
      <img
        src="/images/image.png"
        alt=""
        aria-hidden
        loading="lazy"
        className="hidden md:block absolute -bottom-48 -right-48 w-96 h-96 object-cover rounded-full pointer-events-none z-0"
      />

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 relative z-10">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-ifys-blue mb-6 md:mb-8 tracking-tight">
          Who we are
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_auto] gap-10 lg:gap-12 items-start">
          <div>
            <div className="space-y-4 text-ifys-blue text-base md:text-lg leading-relaxed">
              <p>
                At IFYS our goal is simple, to Strengthen the Human Spirit. To achieve this, we seek
                out exceptional people with aligned values to deliver services that support
                vulnerable members of our communities. Whether it&apos;s our corporate services, our
                front-line staff, or our executive leaders, we are united by our common goal to make
                a positive difference to the lives of others.
              </p>
              <p>
                Given the dynamic nature of our industry, we consistently witness a substantial
                influx of individuals entering and exiting our organisation at various stages of
                their personal journey. In order to seamlessly assist them throughout their
                transition into, during, and out of our organisation, we require a dedicated team of
                professionals.
              </p>
            </div>
            <Button
              href="/our-story/ifys-story"
              variant="primary"
              size="lg"
              className="mt-8"
            >
              Learn More
            </Button>
          </div>

          {/* Statement of Commitment — clickable preview */}
          <a
            href={STATEMENT_PDF}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open IFYS Statement of Commitment (PDF, opens in a new tab)"
            className="group relative block w-full max-w-[280px] sm:max-w-[320px] mx-auto lg:mx-0 lg:w-[300px] xl:w-[340px] focus:outline-none focus-visible:ring-2 focus-visible:ring-ifys-blue focus-visible:ring-offset-2 rounded-sm transition-transform duration-300 hover:-translate-y-0.5"
          >
            <img
              src="/images/statement-of-commitment.png"
              alt="IFYS Statement of Commitment"
              className="block w-full h-auto"
              loading="lazy"
            />
            <span
              aria-hidden="true"
              className="pointer-events-none absolute bottom-3 right-3 inline-flex items-center gap-1.5 rounded-full bg-white/95 text-ifys-blue text-xs sm:text-sm font-semibold px-3 py-1.5 shadow ring-1 ring-gray-200 opacity-0 translate-y-1 transition-all duration-200 group-hover:opacity-100 group-hover:translate-y-0 group-focus-visible:opacity-100 group-focus-visible:translate-y-0"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 3h7v7M21 3l-9 9M10 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-4" />
              </svg>
              View PDF
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
